module.exports = __webpack_public_path__ + "img/Plague Invader.c93416ec.png";